import React from 'react'
import { createRoot } from 'react-dom/client'
import { Amplify } from 'aws-amplify'
import App from './App'

// The Cognito Identity Pool provides unauthenticated AWS credentials with
// exactly one permission: rekognition:StartFaceLivenessSession.
// The backend generates the session ID and fetches the results — this page
// only streams camera frames to AWS using those temporary guest credentials.
const IDENTITY_POOL_ID = import.meta.env.VITE_LIVENESS_IDENTITY_POOL_ID

if (IDENTITY_POOL_ID) {
  Amplify.configure({
    Auth: {
      Cognito: {
        identityPoolId: IDENTITY_POOL_ID,
        allowGuestAccess: true,
      },
    },
  })
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
